import {Component, Input, OnInit} from '@angular/core';
import { CartPrice } from '../../../../../projects/shared-lib/src/lib/models/cart-price';
import { CartLineComponent } from '../cart-line/cart-line.component';

@Component({
    selector: 'tw-cart-detail',
    templateUrl: './cart-detail.component.html',
    styleUrls: ['./cart-detail.component.css'],
    imports: [CartLineComponent]
})
export class CartDetailComponent implements OnInit {

    @Input() cartPrices: any |CartPrice[];
    @Input() location: any;

    constructor() {
    }

    ngOnInit() {
    }

}
